import React,{useState} from 'react';
import {motion} from 'framer-motion';
import PageHeader from '../components/ui/PageHeader';
import CTASection from '../components/home/CTASection';
import VehicleNote from '../components/ui/VehicleNote';
import {siteData} from '../data/content';
import * as FiIcons from 'react-icons/fi';
const {FiCheck,FiArrowRight,FiPhone,FiShield}=FiIcons;

const BOOKING_URL="https://app.urable.com/virtual-shop/cFNwotdAvEx76Evup5X1";

const vehicleTypes=[ 
  {key: 'sedan',label: 'Sedan'},
  {key: 'truck',label: 'Truck / SUV'},
  {key: 'xl',label: 'Van / XL SUV'},
];
const addons=siteData.addons;

export default function Packages() {
  const [activeVehicle,setActiveVehicle]=useState('sedan');

  return ( 
    <div className="bg-slate-950"> 
      <PageHeader title="Detailing Packages" subtitle="Real packages. Real pricing. Built for Jacksonville drivers." /> 
      <div className="py-24"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-8"> 
            <p className="text-slate-400 text-base mb-6">Select your vehicle type to see pricing:</p> 
            <div className="inline-flex bg-slate-900 border border-slate-800 rounded-sm p-1 gap-1"> 
              {vehicleTypes.map((v)=> ( 
                <button key={v.key} onClick={()=> setActiveVehicle(v.key)} className={`px-6 py-3 text-xs font-bold uppercase tracking-widest rounded-sm transition-all ${activeVehicle===v.key ? 'bg-blue-600 text-white shadow-[0_0_12px_rgba(37,99,235,0.4)]' : 'text-slate-400 hover:text-white'}`} > 
                  {v.label} 
                </button> 
              ))} 
            </div> 
          </div> 
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 mb-6"> 
            {siteData.packages.map((pkg,index)=> ( 
              <motion.div key={pkg.id} initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{delay: index * 0.1}} className={`relative flex flex-col rounded-sm border ${pkg.featured ? 'border-blue-500 bg-slate-900 shadow-[0_0_40px_rgba(37,99,235,0.15)] lg:-mt-4 lg:mb-4' : 'border-slate-800 bg-slate-900/60'}`} > 
                {pkg.featured && ( 
                  <div className="bg-blue-600 text-white text-center py-2 text-xs font-black uppercase tracking-widest"> 
                    ⭐ Most Popular 
                  </div> 
                )} 
                <div className="p-8 flex flex-col flex-grow"> 
                  <div className="border-b border-slate-800 pb-6 mb-6"> 
                    <span className="text-blue-500 text-xs font-bold uppercase tracking-widest block mb-2">{pkg.tier}</span> 
                    <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-1">{pkg.name}</h3> 
                    <p className="text-slate-400 text-sm italic mb-5">{pkg.tagline}</p> 
                    <motion.div key={activeVehicle} initial={{opacity: 0,y: -6}} animate={{opacity: 1,y: 0}}> 
                      <div className="text-4xl font-black text-white">{pkg.pricing[activeVehicle]}</div> 
                      <p className="text-slate-500 text-xs mt-1"> 
                        {activeVehicle==='sedan' ? 'Sedan' : activeVehicle==='truck' ? 'Truck / SUV' : 'Van / XL SUV'} 
                      </p> 
                    </motion.div> 
                  </div> 
                  <p className="text-slate-400 text-sm mb-6 leading-relaxed">{pkg.desc}</p> 
                  <ul className="space-y-3 mb-8 flex-grow"> 
                    {pkg.features.map((feature,i)=> ( 
                      <li key={i} className="flex items-start gap-3 text-slate-300 text-sm"> 
                        <FiCheck className="text-blue-500 mt-0.5 flex-shrink-0" /> 
                        <span>{feature}</span> 
                      </li> 
                    ))} 
                  </ul> 
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={`w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-sm font-bold uppercase tracking-wide text-sm transition-all ${pkg.featured ? 'bg-blue-600 text-white hover:bg-blue-500' : 'border-2 border-slate-700 text-white hover:border-blue-500 hover:text-blue-400'}`} > 
                    Book Now <FiArrowRight className="text-xs" /> 
                  </a> 
                </div> 
              </motion.div> 
            ))} 
          </div> 
          {/* Vehicle sizing note */} 
          <div className="mb-4"> 
            <VehicleNote variant="default" /> 
          </div> 
          <p className="text-center text-slate-500 text-sm italic mb-16"> 
            * Pricing may vary based on vehicle condition. Deposit may be required for new customers. 
          </p> 
          {/* Ceramic upsell */} 
          <div className="bg-gradient-to-r from-blue-900/30 to-blue-800/10 border border-blue-500/30 rounded-sm p-8 md:p-12 mb-12 flex flex-col md:flex-row items-center gap-8"> 
            <div className="flex-shrink-0"> 
              <FiShield className="text-blue-500 text-5xl" /> 
            </div> 
            <div className="flex-grow"> 
              <span className="text-blue-400 text-xs font-bold uppercase tracking-widest block mb-2">Premium Upgrade</span> 
              <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-2">Ask About Our 5-Year Ceramic Coating Service</h3> 
              <p className="text-slate-400 text-sm leading-relaxed"> 
                Our Elite Detail includes 1-year ceramic protection — but for ultimate,long-lasting defense,ask us about upgrading to our professional 5-Year Ceramic Coating. Hydrophobic,UV-resistant,and stunning. 
              </p> 
            </div> 
            <div className="flex-shrink-0 flex flex-col gap-3"> 
              <a href="tel:9048312184" className="inline-flex items-center gap-2 px-6 py-3.5 bg-blue-600 text-white font-bold rounded-sm hover:bg-blue-500 transition-all uppercase tracking-wide text-sm whitespace-nowrap" > 
                <FiPhone className="text-sm" /> Call to Ask 
              </a> 
            </div> 
          </div> 
          {/* Add-ons */} 
          <div className="bg-slate-900 border border-slate-800 p-8 md:p-12 rounded-sm"> 
            <h3 className="text-2xl font-black text-white uppercase tracking-tight mb-2">Add-On Services</h3> 
            <p className="text-slate-400 mb-8 text-sm">Customize any package with the following add-ons. Pricing varies by vehicle condition.</p> 
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"> 
              {addons.map((addon,i)=> ( 
                <div key={i} className="flex items-center gap-3 bg-slate-950 border border-slate-800 p-4 rounded-sm"> 
                  <FiCheck className="text-blue-500 flex-shrink-0" /> 
                  <span className="text-slate-300 text-sm font-semibold">{addon.name}</span> 
                </div> 
              ))} 
            </div> 
          </div> 
        </div> 
      </div> 
      <CTASection /> 
    </div> 
  );
}